import React, { FC, Fragment, MouseEventHandler, useState } from 'react'
import { observer } from 'mobx-react'
import { filter } from '@dt/fe-utils/dist/lodash'
import { IonPopover } from '@ionic/react'
import { money } from './util'
import payMobx, { ICard } from '@mobx/pay/pay.mobx'
import EmptyChip from './EmptyChip'
import AmountKeyboard from './AmountKeyboard'
import BankCardOnlineMenuItem from './bankCardOnline/MenuItem'
import BankCardOnlineChip from './bankCardOnline/Chip'
import GiftCardMenuItem from './giftCard/MenuItem'
import GiftCardChip from './giftCard/Chip'
import MemberBalanceChip from './memberBalance/Chip'
import AlipayMenuItem from './alipay/MenuItem'
import AlipayChip from './alipay/Chip'
import WechatPayMenuItem from './wechatPay/MenuItem'
import WechatPayChip from './wechatPay/Chip'
import ApplePayMenuItem from './applePay/MenuItem'
import ApplePayChip from './applePay/Chip'
import PayPalChip from './paypal/Chip'
import PayPalMenuItem from './paypal/MenuItem'

interface IProps {
  method?: string;
  card?: ICard;
  amount: number;
  total: number;
  message?: string;
  onSelect?(method: string, card?: ICard): void;
  onDeleteCard?(method: string, card?: ICard): void;
  onAmountChange?(amount: number): void;
}

export interface IMenuItemProps {
  currentCard?: ICard;
  onSelect?(method: string, card?: ICard): void;
  onDeleteCard?(method: string, card?: ICard): void;
}

export interface IChipProps {
  card?: ICard;
  onClick?: MouseEventHandler;
}

const Bill: FC<IProps> = ({ method, card, amount, total, message, onSelect, onDeleteCard, onAmountChange }) => {
  const [showMenuEvent, setShowMenuEvent] = useState(null)
  const [showAmountKeyboard, setShowAmountKeyboard] = useState(false)

  const methods = [
    {
      key: 'bankCardOnline',
      chipComponent: BankCardOnlineChip,
      menuItemComponent: BankCardOnlineMenuItem
    },
    {
      key: 'giftCard',
      chipComponent: GiftCardChip,
      menuItemComponent: GiftCardMenuItem
    },
    {
      key: 'memberBalance',
      chipComponent: MemberBalanceChip
    },
    {
      key: 'alipay',
      chipComponent: AlipayChip,
      menuItemComponent: AlipayMenuItem
    },
    {
      key: 'wechatPay',
      chipComponent: WechatPayChip,
      menuItemComponent: WechatPayMenuItem
    },
    {
      key: 'applePay',
      chipComponent: ApplePayChip,
      menuItemComponent: ApplePayMenuItem
    }
    // ,{
    //   key: 'paypal',
    //   chipComponent: PayPalChip,
    //   menuItemComponent: PayPalMenuItem
    // }
  ]

  const enabledMethods = filter(methods, x => !!payMobx.methodChannelMap[x.key])
  const selectedMethod = enabledMethods.find(x => x.key === method)
  console.log(enabledMethods, 'enabledMethods~~~~~~~~~~`')
  return (
    <>
      <div className={'item' + (message ? ' has-message' : '')}>
        {selectedMethod ? (
          <selectedMethod.chipComponent card={card} onClick={e => setShowMenuEvent(e.nativeEvent)} />
        ) : (
          <EmptyChip onClick={e => setShowMenuEvent(e.nativeEvent)} />
        )}
        <div className='amount' onClick={() => method === 'memberBalance' && setShowAmountKeyboard(true)}>
          {money(amount)}
        </div>
        {!!message && (
          <div className='message'>{message}</div>
        )}
      </div>
      <IonPopover
        isOpen={showMenuEvent != null}
        event={showMenuEvent}
        showBackdrop={false}
        cssClass='pay-method-select-popover'
        onDidDismiss={() => setShowMenuEvent(null)}
      >
        <ul>
          {enabledMethods.map(method => (
            <Fragment key={method.key}>
              {method.menuItemComponent && (
                <method.menuItemComponent
                  currentCard={card}
                  onSelect={(method, card) => {
                    setShowMenuEvent(null)
                    onSelect(method, card)
                  }}
                  onDeleteCard={(method, card) => {
                    setShowMenuEvent(null)
                    onDeleteCard(method, card)
                  }}
                />
              )}
            </Fragment>
          ))}
        </ul>
      </IonPopover>
      <AmountKeyboard
        visible={showAmountKeyboard}
        amount={amount}
        max={total}
        header={selectedMethod && <selectedMethod.chipComponent card={card} />}
        onSave={(amount) => {
          onAmountChange(amount)
          setShowAmountKeyboard(false)
        }}
        onClose={() => setShowAmountKeyboard(false)}
      />
    </>
  )
}

export default observer(Bill)
